// §4.14's last Forecast sentence: "`/sales/analytics` links to it" (P3-E2 PR
// E2-1). One card on the analytics screen, offered to a reader who can open
// the forecast: the pipeline's audience holding the value grant, because the
// forecast is a value door (§7 narrowing 7) and a link into its refusal
// sentence is the D-088 shape.

import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Card } from "../../../../../components/card";
import { canOpenForecast, useSalesPermissions } from "../../hooks/permissions";

export function ForecastLinkCard() {
  const { t } = useTranslation();
  const perms = useSalesPermissions();
  if (!canOpenForecast(perms, perms.has)) return null;
  return (
    <Card
      className="sales-360-card"
      data-testid="sales-analytics-forecast"
      title={t("sales.analytics.forecastTitle")}
    >
      <p className="sales-hint">{t("sales.analytics.forecastBody")}</p>
      <p>
        <Link to="/sales/forecast" className="ds-lnk" data-testid="sales-analytics-forecast-link">
          {t("sales.analytics.forecastLink")}
        </Link>
      </p>
    </Card>
  );
}
